import { GET_FILTER_LOG_UNDO, GET_LOG_UNDO, LogGrid } from "../../../Model/Log"

const initState: LogGrid = {
    LogGridResult: null,
    filter: null,
}
//const dispatch = useDispatch();


export const LogUndoGridReducer = (state = initState, action: { type: string, payload: LogGrid }) => {
    switch (action.type) {
        case GET_LOG_UNDO:
            {
                return { ...state, LogGridResult: action.payload.LogGridResult }
            }
        case GET_FILTER_LOG_UNDO:
            return { ...state, filter: action.payload.filter }
        default:
            return state;
    }
}
